<!--Toasts-->
<p-toast baseZIndex="1000" key="notification" position="top-right"></p-toast>
<p-toast #cedeToast baseZIndex="1000" key="cedeLock" position="bottom-right" styleClass="cede-toast">
  <ng-template let-message pTemplate="message">
    <div *ngIf="!message.data.timerObj">
      <div>
        <h3 style="color: var(--ui-color-light)"><i [className]="message.data.icon"></i> {{message.summary}}</h3>
        <p style="color: var(--ui-color-light)">{{message.detail}}</p>
      </div>
      <div class="grid fluid-ui-replacer">
        <div class="col-6">
          <button (click)="message.data.positiveAction();commonClose(message)" class="col-12 p-nogutter" p-button
                  pRipple
                  pRipple
                  style="background-color: var(--ui-color-light); color: var(--ui-color-dark)">{{message.data.positiveString}}</button>
        </div>
        <div class="col-6">
          <button (click)="message.data.negativeAction();commonClose(message)" class="col-12 p-nogutter" p-button
                  pRipple
                  pRipple
                  style="background-color: var(--ui-color-light); color: var(--ui-color-dark)">{{message.data.negativeString}}</button>
        </div>
      </div>
    </div>
    <div *ngIf="message.data.timerObj">
      <div>
        <h3 style="color: var(--ui-color-light)"><i [className]="message.data.icon"></i>
          Expires {{getTimeLeft(message)}}</h3>
        <p style="color: var(--ui-color-light)">{{message.detail}}</p>
      </div>
      <div class="p-grid fluid-ui-replacer">
        <div class="col-12">
          <button (click)="message.data.action()" class="col-12 p-nogutter" p-button
                  pRipple
                  pRipple style="background-color: var(--ui-color-light); color: var(--ui-color-dark)">{{message.data.buttonText}}</button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<!--Globals-->
<app-updater *ngIf="electronService.isElectronApp && env.production && !updaterService.hiddenUI"></app-updater>
<app-title-bar *ngIf="electronService.isElectronApp" [showSettings]="false"></app-title-bar>
<app-side-nav *ngIf="appStateService.appWindowState === AppWindowState.Main" [tab]="tabbingService.visibleTab" [(extended)]="isSideNavExtended"></app-side-nav>
<app-please-wait [hidden]="!pleaseWaitService.waiting"></app-please-wait>
<app-side-dial></app-side-dial>
<app-assistant-window *ngIf="appStateService.appWindowState === AppWindowState.Main"></app-assistant-window>
<p-confirmDialog [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '50vw' }"></p-confirmDialog>
<w-appointment-notifications-holder></w-appointment-notifications-holder>

<!--Static Pages-->
<app-login-page *ngIf="appStateService.appWindowState === AppWindowState.Login"></app-login-page>
<app-register-trial-page *ngIf="appStateService.appWindowState === AppWindowState.Register"></app-register-trial-page>
<app-forgot-password-page *ngIf="appStateService.appWindowState === AppWindowState.ForgotPassword"></app-forgot-password-page>
<app-tenant-selection-page *ngIf="appStateService.appWindowState === AppWindowState.Tenant"></app-tenant-selection-page>
<app-force-update-screen *ngIf="appStateService.appWindowState === AppWindowState.ForceUpdate"></app-force-update-screen>

<!--Tabs-->
<div style="width: 100%;transition: 0.4s ease-in;" [class.web]="!electronService.isElectronApp"
     [class.electron]="electronService.isElectronApp" [class.content-shift-right]="isSideNavExtended">
  <app-tab *ngFor="let tab of tabbingService.tabs" [tab]="tab"></app-tab>
</div>
<app-snippet-popup></app-snippet-popup>
<app-tooltip-renderer></app-tooltip-renderer>
